import loadingSpinner from './components/loading-spinner'

export class StepConnectedTryWifi {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "connected_try_wifi";
  title = "Testing WiFi Connection";

  template = `
  <div class="onboarding-step" data-for="connected_try_wifi">
          
    <p class="onboarding-guide-instruction-smaller text-center">
      Connecting your Temp Stick to your WiFi network and testing the internet connection...
    </p>
    
    <div class="onboarding-loading">
      <div class="onboarding-loading__animation">${loadingSpinner()}</div>
      <div class="onboarding-loading__text">
        Please Wait
      </div>
    </div>
    
  </div>
  `;

  onBack = () => {

  }

  onActivate = () => {
    this.onboarding.is_trying_wifi = true;
    this.onboarding.hideBackButton();
  }

  bindActions = () => {

  }

}
